import { Vue, Component, Mixins, Prop, Watch } from 'vue-property-decorator';

@Component({})
export default class TileComponentMixin extends Vue {
    // If true, this should show the picker icon + configurator modal
    @Prop({required: true})
    public isPicker: boolean;

    @Prop({required: true})
    public deviceNumber: string;

    @Prop({required: false, default: false})
    public isEditing: boolean;

    public showConfigurator() {
        (this.$refs.configurator as any).show();
        this.$emit('configurator-showing');
    }

    @Watch('available')
    public availabilityChange() {
        if ((this as any).available !== undefined) {
            this.$emit('available', (this as any).available);
        }
    }

    public mounted() {
        this.availabilityChange();
    }
}
